/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientName from './patient-name';
import PatientNameDetail from './patient-name-detail';
import PatientNameUpdate from './patient-name-update';
import PatientNameDeleteDialog from './patient-name-delete-dialog';

const PatientNameRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientName />} />
    <Route path="new" element={<PatientNameUpdate />} />
    <Route path=":id">
      <Route index element={<PatientNameDetail />} />
      <Route path="edit" element={<PatientNameUpdate />} />
      <Route path="delete" element={<PatientNameDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientNameRoutes;
